<mat-card>
    <mat-card-header><h2>Waiting for Approval</h2></mat-card-header>
    <mat-card-content>Approval is needed in order to finish setting up your account.  Check back here later or contact us if needed.</mat-card-content>
</mat-card>